import React from 'react';
import {FaCalendar} from "react-icons/fa";
import projectUtils from "../../../../../../utils/project-utils.js";
import BaseNode from "./base-node.jsx";
import {Types} from "../enums.js";
import {getAssetPath} from "../../../../../../utils/get-asset-path.js";
import CheckHasData from "../check-has-data.jsx";

const CoincidentPassages = ({data, selected}) => {
    const icon = (
        <img
            className="m-auto w-[18px]"
            src={getAssetPath("img/dashboard-svg/sw.analyse.svg")}
            alt="image"
        />
    );

    const title = (
        <>
            <p className={"!mb-[2px] text-[#fff]"}><b>Análise de coincidências</b></p>
            <p className={"mb-0 text-[6px] text-[#fff]"}>{data.filter.plate}</p>
        </>
    )

    const infoBlock = (
        <div className="p-1 text-[7px] border-top border-bottom !border-[#cfcfcf]">
            <div className={"flex items-center"}>
                <FaCalendar/>
                <p className={"ml-1 mb-0"}>Data inicial: <CheckHasData value={projectUtils.formatDate(data.filter.startDate)} /></p>
            </div>

            <div className={"flex items-center"}>
                <FaCalendar/>
                <p className={"ml-1 mb-0"}>Data final: <CheckHasData value={projectUtils.formatDate(data.filter.endDate)} /></p>
            </div>
        </div>
    )

    return (
        <BaseNode
            icon={icon}
            title={title}
            image={null}
            onSearchConnections={false}
            infoBlock={infoBlock}
            showAddConnectionButton={true}
            selected={selected}
            bgHeader={"bg-[#6A4D9F]"}
            bgBody={"bg-[#ffffff]"}
            type={Types.COINCIDENT_PASSAGES}
        />
    );
};

export default CoincidentPassages;